import { Component, OnInit } from '@angular/core';
import { ChartConfiguration, ChartOptions } from "chart.js";
import { EcitationReportService } from 'src/services/ecitation-report.service';

@Component({
    selector: 'app-ecitation-hourly-usage-report',
    templateUrl: './ecitation-hourly-usage-report.component.html',
    styleUrls: ['./ecitation-hourly-usage-report.component.css'],
    standalone: false
})
export class EcitationHourlyUsageReportComponent implements OnInit {
  title = 'ng2-charts-demo';

  public lineChartData: ChartConfiguration<'line'>['data'] | undefined;
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true
  };
  public lineChartLegend = true;
  
  constructor(private ecitationReportService: EcitationReportService) { }
  ngOnInit(): void {
    let lables:any =[];
    let data:any =[]
    this.ecitationReportService.getHourlyUsageReport().subscribe((res:any) => {
      
      res.forEach((x: any) => {
        lables.push(x.hour)
        data.push(x.citationCount)
        this.lineChartData=
        {
          labels: lables,
          datasets: [
            { data: data,
              label: 'Series A',
        fill: false,
        tension: 0.5,
            }
          ]
        };
      
      });
    });
  }
}
